<template>
  <div class="default-page-wrapper" :class="`${is_expanded ? 'is_expanded-body' : 'not-expended'}`" >
    <div class="wrapper-sidebar">
      <HeadeSidebar />
      <Sidebar :is_expanded="is_expanded" :hasRes="hasRes"   />
    </div>
    <div class="wrapper-content">
      <HeaderContent @ToggleMenu="ToggleMenu"  />
      <slot />
      <FooterElement/>
    </div>
    
  </div>
</template>

<script>
import Sidebar from "../components/navigation/Sidebar.vue";
import HeaderContent from "../components/navigation/HeaderContent.vue";
import HeadeSidebar from "../components/navigation/HeaderSidebar.vue";
import FooterElement from '../components/navigation/Footer.vue';
export default {
  components: {
    HeadeSidebar,
    Sidebar,
    FooterElement,
    HeaderContent
  },
  data(){
    return{
      is_expanded: true,
      hasRes:false
    }
  },
  created(){
    JSON.parse(localStorage.getItem("is_expanded")) ?  this.is_expanded= JSON.parse(localStorage.getItem("is_expanded")) : "";
  },
  methods:{
     ToggleMenu(){
      this.is_expanded=!this.is_expanded;
      localStorage.setItem("is_expanded", this.is_expanded)
    
      this.hasRes=!this.hasRes
    }
  }
}
</script>

<style lang="scss">
</style>